import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { TransactionService } from './transaction.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isLoggedIn = false
  user

  constructor(private http:HttpClient, private router: Router, private transactionService : TransactionService) { }

  Login(loginForm){
    return this.http.post(`${environment.apiUrl}/auth/local`, loginForm)
  }

  Register(registerForm){
    return this.http.post(`${environment.apiUrl}/auth/local/register`, registerForm)
  }

  ForgotPassword(forgotPasswordForm){
    return this.http.post(`${environment.apiUrl}/auth/forgot-password`, forgotPasswordForm)
  }

  ResetPassword(resetPasswordForm){
    return this.http.post(`${environment.apiUrl}/auth/reset-password`, resetPasswordForm)
  }

  isAuthenticated(){
    if(localStorage.getItem("res")){
      this.isLoggedIn = true
      this.user = JSON.parse(localStorage.getItem("res")).user
      return true
    }
    else{
      return false
    }
  }

  signOut(){
    localStorage.removeItem("res")  
    localStorage.removeItem("walletconnect") 
    this.transactionService.disconnectWallet()
    this.router.navigateByUrl('/')
  }
}
